module.exports = __webpack_public_path__ + "static/media/0356_Small.f4ab00af.jpg";